import { toast } from 'react-toastify';
import styles from './EmailVerificationFailedBlock.module.scss';
import { useQueryParams } from 'src/hooks';
import { resendSignUpCode } from 'aws-amplify/auth';
import { ServiceError } from '@aws-amplify/core/src/types/errors';
import { Button } from 'src/v2/commonComponents/Button';
import { COMMON_ERROR_TEXT } from 'src/constants';

export const EmailVerificationFailedBlock = () => {
  const { searchParams } = useQueryParams();
  const { username } = searchParams;

  const handleResendLink = async () => {
    try {
      if (username) {
        await resendSignUpCode({ username });
        toast('Verification link resent');
      }
    } catch (error) {
      toast.error(error ? (error as ServiceError).message : COMMON_ERROR_TEXT);
    }
  };

  return (
    <div className={styles.verifiedBlock}>
      <h2>Verification email expired</h2>
      <p className={styles.verifiedText}>
        Your verification email has expired.
      </p>
      <Button onClick={handleResendLink}>Resend email verification</Button>
    </div>
  );
};
